// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2MjDv","inputWrap":"CustomTip_inputWrap__182j_"};